<div
  class="custom-popup"
  [ngClass]="{
    'tooltip-bottom': direction === 'bottom',
    'tooltip-top': direction === 'top',
  }"
  [style.visibility]="positioned ? 'visible' : 'hidden'"
>
  {{ content }}
</div>
